import React from 'react';
import '../styles/WelcomeGuide.css';

interface WelcomeGuideProps {
  onNext: () => void;
}

const WelcomeGuide: React.FC<WelcomeGuideProps> = ({ onNext }) => {
  return (
    <div className="welcome-container">
      <div className="welcome-content">
        <div className="welcome-icon">
          <div className="health-icon">📱</div>
        </div>
        
        <h1 className="welcome-title">健康档案</h1>
        
        <div className="welcome-description">
          <p>智能分析健康数据，提供个人专属的健康洞察</p>
        </div>
        
        <div className="features-list-new">
          <div className="feature-row">
            <div className="feature-item-new">
              <div className="feature-content">
                <span className="feature-title">智能分析</span>
                <span className="feature-desc">AI驱动的健康评估</span>
              </div>
            </div>
            <div className="feature-item-new">
              <div className="feature-content">
                <span className="feature-title">趋势跟踪</span>
                <span className="feature-desc">指标变化一目了然</span>
              </div>
            </div>
          </div>
          <div className="feature-row">
            <div className="feature-item-new">
              <div className="feature-content">
                <span className="feature-title">风险预警</span>
                <span className="feature-desc">提前发现健康隐患</span>
              </div>
            </div>
            <div className="feature-item-new">
              <div className="feature-content">
                <span className="feature-title">个性建议</span>
                <span className="feature-desc">量身定制健康方案</span>
              </div>
            </div>
          </div>
        </div>
        
        <button className="claim-button" onClick={onNext}>
          开始使用
        </button>
        
        <p className="privacy-note">
          数据安全加密存储
        </p>
      </div>
    </div>
  );
};

export default WelcomeGuide;